<div class="pdf-container">
    <mat-form-field class="full-width-input">
        @if (PreviewSearchControl.value != null && PreviewSearchControl.value != '') {
        <button mat-icon-button matPrefix (click)="PreviewSearchControl.setValue(null);"
            [attr.aria-label]="'Reset preview search'">
            <mat-icon>clear</mat-icon>
        </button>
        }
        <mat-label>Search Document</mat-label>
        <input type="text" matInput [maxLength]="300" placeholder="Search..." (keyup.enter)="searchPreview()"
            [formControl]="PreviewSearchControl">
        <button mat-icon-button matSuffix (click)="searchPreview()" [attr.aria-label]="'Search Preview'">
            <mat-icon>search</mat-icon>
        </button>
    </mat-form-field>
    @if (url != null) {
        <div class="pdf-display">
            <pdf-viewer #pdfComponent [src]="url" [original-size]="true" [show-all]="true" [render-text]="true" style="width: 100%; height: 100vh"
                [render-text-mode]="2" [external-link-target]="'blank'" [fit-to-page]="true" [show-borders]="true"></pdf-viewer>
        </div>
    }
</div>